<div class="row">
  <div class="col d-flex justify-content-center mt-3">
    <div class="login-error-icon"></div>
  </div>
</div>

<div class="row">
  <div class="col d-flex justify-content-center text-center pl-5 pr-5">
    @if (errorCode === 409) {
      <span
        class="text text-title pl-5 pr-5"
        [innerHTML]="'home.profile.login-error-already-registered.title' | translate"></span>
    } @else {
      <span
        class="text text-title pl-5 pr-5"
        [innerHTML]="'home.profile.login-error.title' | translate"></span>
    }
  </div>
</div>

<div class="row mt-2">
  <div class="col d-flex justify-content-center text-center pl-5 pr-5">
    @if (errorCode === 409) {
      <span
        class="text text-subtitle pl-5 pr-5"
        [innerHTML]="'home.profile.login-error-already-registered.subtitle' | translate: { platform: platform }"></span>
    } @else {
      <span
        class="text text-subtitle pl-5 pr-5"
        [innerHTML]="'home.profile.login-error.subtitle' | translate: { platform: platform }"></span>
    }
  </div>
</div>

<div class="row mt-4">
  <div class="col d-flex justify-content-center text-center pl-5 pr-5">
    @if (errorCode === 409) {
      <span
        class="text text-content pl-5 pr-5"
        [innerHTML]="'home.profile.login-error-already-registered.message' | translate"></span>
    } @else {
      <span
        class="text text-content pl-5 pr-5"
        [innerHTML]="'home.profile.login-error.message' | translate"></span>
    }
  </div>
</div>

<div class="row">
  <div class="col d-flex justify-content-center">
    <slotcom-button
      class="c-button--pink"
      (click)="closeDialog()"
      audioType="functionality">
      {{ 'home.buttons.back' | translate }}
    </slotcom-button>
  </div>
</div>
